/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-unresolved */
import moment from "moment";
import StorageService from "src/utils/Storage/storageService";
import { roleIDs } from "src/config/constant";
import { OPTIONS } from "./resources";
import { products } from "../FormDetails/resources";
import { statusToBucketStringMap } from ".";

const columnHeadings = () => {
  const user = StorageService.getFromLocalStorage("user");
  return [
    {
      name: "applicationNo",
      label: "Bank App. No.",
      filterSort: true
    },
    {
      name: "clcApplicationNo",
      label: "CLC App. No.",
      filterSort: false
    },
    {
      name: "lifeInsurerName",
      label: "Customer Name",
      filterSort: true
    },
    {
      name: "mobile",
      label: "Mobile No.",
      filterSort: false
    },
    {
      name: "nationality",
      label: "Nationality",
      filterSort: false
    },
    {
      name: "lifeInsurerDob",
      label: "DOB \n (DD-MM-YYYY)",
      filterSort: true
    },
    {
      name: "loanAccNo",
      label: "Loan Acc. No.",
      filterSort: false
    },
    {
      name: "proposalStatus",
      label: "Proposal \n Status",
      filterSort: false
    },
    { name: "ibpsStatus", label: "IBPS Status", filterSort: false },
    {
      name: "loanStatus",
      label: "Loan Status",
      filterSort: false
    },
    {
      name: "solId",
      label: "Sol ID",
      filterSort: true
    },
    {
      name: "sumAssured",
      label: "Sum Assured \n (in Rs.)",
      filterSort: true
    },
    {
      name: "term",
      label: "Policy Term",
      filterSort: true
    },
    {
      name: "totalpremium",
      label: "Premium \n (in Rs.)",
      filterSort: true
    },
    {
      name: "proposalReceivedDate",
      label: "Created on \n (DD-MM-YYYY)",
      filterSort: true
    },
    {
      name: "source",
      label: "Source",
      filterSort: false
    },
    ...(user?.role !== roleIDs.bankEmployee
      ? [
          {
            name: "partner",
            label: "Partner",
            filterSort: false
          }
        ]
      : []),
    {
      name: "sparkDecision",
      label: "Spark Decision",
      filterSort: false
    },
    {
      name: "paymentStatus",
      label: "Payment Status",
      filterSort: false
    },
    {
      name: "amountPaid",
      label: "Amount Paid \n (in Rs.)",
      filterSort: true
    },
    { name: "requirementStatus", label: "Requirement Status", filterSort: false },
    {
      name: "action",
      label: "Action",
      filterSort: false
    },
    {
      name: "formType",
      label: "Form Type",
      filterSort: false
    },
    {
      name: "download",
      label: "Download",
      filterSort: false
    },
    {
      name: "caseReassign",
      label: "Case Reassign",
      filterSort: false
    },
    ...(user?.role === roleIDs.superAdmin
      ? [
          {
            name: "workflow",
            label: "Workflow",
            filterSort: false
          }
        ]
      : [])
  ];
};
const rowData = (data: any) => {
  const user = StorageService.getFromLocalStorage("user");
  const obj: Record<string, any> = {};
  data?.data?.forEach((row: any) => {
    const currentRow = {
      applicationNo: row?.applicationNo || "-",
      clcApplicationNo: row?.clcAppNo || "-",
      lifeInsurerName: row?.lifeInsurerName || "-",
      mobile: row?.mobile || "-",
      nationality:
        OPTIONS.nationality[row?.lifeInsurerNationality || "RES"] || OPTIONS.nationality.RES,
      lifeInsurerDob:
        (row?.lifeInsurerDob && moment(row?.lifeInsurerDob).format("DD-MM-YYYY")) || "-",
      loanAccNo: row?.loanAccountNo || "-",
      proposalStatus: row?.proposalStatus || "-",
      ibpsStatus: statusToBucketStringMap[row?.ibpsStatus] || "-",
      loanStatus: row?.loanStatus || "-",
      solId: row?.solId || "-",
      sumAssured: Number(row?.sumAssured).toLocaleString("en-IN") || "-",
      term:
        (row?.policyTerm &&
          `${row?.policyTerm} ${
            [
              products?.GHS,
              products?.GHS_FOR_JIO,
              products?.GHS_IDBI,
              products?.GCS,
              products?.GCS_SREI
            ]?.includes(row.productId)
              ? "months"
              : "years"
          }`) ||
        "-",
      totalpremium: Number(row?.totalpremium).toLocaleString("en-IN") || "-",
      proposalReceivedDate:
        (row?.proposalReceivedDate && moment(row?.proposalReceivedDate).format("DD-MM-YYYY")) ||
        "-",
      source: row?.source?.toUpperCase() || "-",
      ...(user?.role !== roleIDs.bankEmployee && {
        partner: row?.partnerId?.toUpperCase() || "-"
      }),
      sparkDecision: row?.sparkFullDecision?.autoUnderwritingStatus?.description || "-",
      paymentStatus: row?.paymentStatus || "Pending",
      amountPaid: (row?.amountPaid && Number(row?.amountPaid).toLocaleString("en-IN")) || "-",
      requirementStatus: row?.followUpRequirements?.every(
        (item: { code?: string; status?: string }) => item?.status === "R"
      )
        ? "Received"
        : "Pending",
      action: row?.proposerBucket || "",
      formType: "BI",
      download: "download",
      caseReassign: "",
      funding: row?.funding,
      ...(user?.role === roleIDs.superAdmin && {
        workflow: "workflow"
      }),
      canEditMEF: row?.canEditMEF
    };
    obj[row?.id] = currentRow;
  });
  return obj;
};

// const filterOptions: string[] = columnHeadings?.map((heading) => heading.label);
export { rowData, columnHeadings };
